module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fk29w"))).then(() => parcelRequire('ikE14'));